module.exports = __webpack_public_path__ + "img/Illustration.207db026.svg";